import script from "./AppointmentsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentsCard.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentsCard.vue?vue&type=style&index=0&id=259090c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259090c5"]])

export default __exports__